import { schema } from './schema.js';
import { gtag } from './analytics.js';

export function socialShares() {
	const shares = document.querySelectorAll('[data-social-network]');
	if (0 == shares.length || !schema.json) return;
	const title =
		schema.get('Article', 'headline') || schema.get('WebSite', 'name');
	const text =
		schema.get('Recipe', 'description') ||
		schema.get('Article', 'description') ||
		schema.get('Organization', 'description');
	const parsed_url = new URL(window.location.href);
	const url = parsed_url.href; // preserving existing query string
	// const utm_medium = parsedUrl.searchParams.get('utm_medium');
	// articles, recipes, and index pages have different locations for images
	const image =
		schema.get('Article', 'image.url') ||
		schema.get('WebPage', 'primaryImageOfPage.url');
	// if we have a custom Pinterest image, use that
	const pinMeta = document.head.querySelector('meta[name="pinterest:image"]');
	const pin = pinMeta ? pinMeta.getAttribute('content') : image;
	let share_urls = {
		Facebook: `https://www.facebook.com/dialog/share?app_id=${
			glp_site_options.social.facebook.app
		}&display=popup&href=${encodeURIComponent(
			url
		)}&redirect_uri=${encodeURIComponent(url)}`,
		Twitter: `https://twitter.com/intent/tweet?text=${encodeURIComponent(
			title
		)}&url=${encodeURIComponent(url)}`,
		Pinterest: `https://pinterest.com/pin/create/button/?s=1&url=${encodeURIComponent(
			url
		)}&media=${encodeURIComponent(pin)}&description=${encodeURIComponent(
			title
		)}`,
	};
	if (glp_site_options.social.instagram) {
		share_urls[
			'Instagram'
		] = `https://www.instagram.com/${glp_site_options.social.instagram.username}`;
	}
	Array.from(shares).forEach((share) => {
		share.addEventListener('click', function (event) {
			const service = this.getAttribute('data-social-network');
			const placement = this.closest('[data-placement]').getAttribute(
				'data-placement'
			);
			if (navigator.share) {
				// we have Web Share API
				navigator
					.share({
						title,
						text,
						url,
					})
					.then(() => {
						gtag('event', 'share', {
							method: service,
							content_type:
								document.body.dataset.posttype ||
								document.body.dataset.template,
							content_id: document.body.dataset.postid || null,
						});
					})
					.catch((error) => {
						gtag('event', 'exception', {
							description: error.message,
						});
					});
			} else {
				// old-school
				event.preventDefault();
				window.open(
					share_urls[service],
					'Sharing',
					'width=720,height=480,menubar=no,location=no,resizable=yes,scrollbars=no,status=yes'
				);
				gtag('event', 'share', {
					method: service,
					content_type:
						document.body.dataset.posttype || document.body.dataset.template,
					content_id: document.body.dataset.postid || null,
				});
			}
		});
	});
}
